import crypto from 'crypto-js';

export const hashValue = (value: string): string => {
  return crypto.SHA256(value).toString();
};
